import React, { useState } from 'react';
import Navbar from './Nav';
import Footer from './Footer';
import Sidebar from './Sidebar';
import './App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact,faJs ,faCss3Alt} from '@fortawesome/free-brands-svg-icons'; 
import Carousel from './Carousel';

import { Link } from "react-router-dom";
import { errortoast, IsEmpty } from './helper/helper';
import { contactApi } from './ApiRequest/Api';
import Loader from './Loader';

const Contact = () => {

  const [contact ,setcontact] =useState({name :"" ,email:"",message:""})
let [loader,setloader]=useState(false)
  const submitcontact =async (e)=>{

    e.preventDefault()
if (IsEmpty(contact.name)) {
  errortoast("Fillup You Name");
}else if(IsEmpty(contact.email)){
  errortoast("Fillup You Email");
}else if (IsEmpty(contact.message)) {
  errortoast("Fillup You Message");
}else{
  setloader(true)
let result =   await contactApi(contact);
setloader(false);
  if (result === true) {
     setcontact({ name: "", email: "", message: "" });
    
 
  } 
}

  }
    return (
      <div className="relative">
        <div className="overflow-x-hidden text-white background elegant ">
          {!!loader === true ? <Loader /> : null}
          <Navbar />
          <div className="w-full container px-5 block md:flex py-24 mx-auto  justify-between">
            <div className="w-full md:w-1/2 lg:w-1/3 mx-2">
              <Sidebar />
            </div>
            <div className="w-full md:w-1/2 lg:w-2/3 mx-auto ">
              <div className="md:bg-zinc-900 rounded-xl  container px-5 py-10">
                <p className="text-lg">
                  <span className="text-lime-500 text-5xl Riesling  font-bold ">
                    Let’s Chat!
                  </span>
                  <br />
                  <br />
                  Feel free to contact us through Twitter or Facebook if you
                  prefer!{" "}
                </p>
              </div>
              <div className="  justify-center mx-auto py-10">
                <form
                  onSubmit={submitcontact}
                  className="bg-zinc-900 rounded-xl container px-5 py-10 z-10"
                >
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                    <div>
                      <input
                        onChange={(e) =>
                          setcontact({ ...contact, name: e.target.value })
                        }
                        value={contact.name}
                        type="text"
                        id="fullName"
                        placeholder="name"
                        className="w-full p-2 border-1  text-green-400 border-white  placeholder:text-zinc-900 border border-gray-700 rounded-md focus:outline-none focus:ring-2 focus:ring-lime-500"
                      />
                    </div>
                    <div>
                      <input
                        onChange={(e) =>
                          setcontact({ ...contact, email: e.target.value })
                        }
                        value={contact.email}
                        type="text"
                        id="email"
                        placeholder="email"
                        className="w-full p-2 border-1  text-green-400 border-white  placeholder:text-zinc-900 border border-gray-700 rounded-md focus:outline-none focus:ring-2 focus:ring-lime-500"
                      />
                    </div>
                  </div>

                  <div className="mb-4">
                    <textarea
                      onChange={(e) =>
                        setcontact({ ...contact, message: e.target.value })
                      }
                      value={contact.message}
                      id="message"
                      rows="5"
                      placeholder="Message!"
                      className="w-full p-2 border-1 text-green-400 border-white  placeholder:text-zinc-900 border border-gray-700 rounded-md focus:outline-none focus:ring-2 focus:ring-lime-500"
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    className="bg-lime-500 hover:bg-lime-200 text-white hover:text-gray-300 font-semibold py-2 px-6 rounded-full focus:outline-none focus:ring-2 focus:ring-lime-400"
                  >
                    Send
                  </button>
                </form>
              </div>
            </div>
          </div>
          <div className=" pb-24 px-4">
            <div className="max-w-6xl mx-auto">
              <div className="mb-8">
                <iframe
                  title="Google Map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3651.6987652219736!2d90.36429777470907!3d23.758119188481125!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755bf57445e48a7%3A0x8d500d510c44a64!2sZakir%20Hossain%20Road%2C%20Dhaka%201205!5e0!3m2!1sen!2sbd!4v1737730331982!5m2!1sen!2sbd"
                  width="100%"
                  height="400"
                  allowFullScreen=""
                  loading="lazy"
                  className="rounded-lg shadow-lg"
                ></iframe>
              </div>

              <div className="bg-zinc-900 rounded-lg shadow-lg p-6 grid md:grid-cols-3 gap-6">
                <div>
                  <h3 className="font-bold text-lg mb-2 text-zinc-400 ">
                    Contact
                  </h3>
                  <p>+88 01644385198</p>
                </div>

                <div>
                  <h3 className="font-bold text-lg mb-2 text-zinc-400 ">
                    {" "}
                    Address
                  </h3>
                  <p>Zakir hossain road ,mohammadpur, Dhaka,</p>
                  <p>Bangladesh.</p>
                </div>

                {/* Email Address */}
                <div>
                  <h3 className="font-bold text-lg mb-2 text-zinc-400 ">
                    Email Address
                  </h3>
                  <p>tayyabmd00001@gmail.com</p>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      </div>
    );
};

export default Contact;